// backhfhhf
import React, { useState, useEffect, useCallback } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import ItemService from "../../../services/supplier_appCommonService";

//Redux
import { useDispatch } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import PageLevelRiverseTimer from "../../../Components/PageLevelRiverseTimer";
import SourcingCommonFilter from "../../../Components/Filter/Sourcing/SourcingCommonFilter";
import toast from "react-hot-toast";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import Constants from "../../../common/SupplierConstants";
import { formatPriceValue, getCurrentDate } from "../../../common/Validations";
import moment from "moment";
import TableDropdownMenu from "../../../Components/TableDropdownMenu/TableDropdownMenu";
import { useSearchParams } from "react-router-dom";
import HeaderText from "./HeaderText";
import { getTndQtnList } from "../../../redux/feature/supplier_app/purchasingSlice";

const CreateQuotation = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Request for Quotation");

  const [data, setData] = useState();
  const productTypeCode = data?.productTypeCode;

  let dropdownOption = [
    {
      id: "1",
      name: "Sample Data 1",
    },
    {
      id: "2",
      name: "Sample Data 2",
    },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);

  const [subTotalValue, setSubTotalValue] = useState(0);
  const [itemTableData, setItemTableData] = useState([]);
  const [timerStatus, setTimerStatus] = useState(false);
  const [finalTimerValue, setFinalTimerValue] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [searchParams] = useSearchParams();

  const [vendorData, setVendorData] = useState(null);

  const rfxNr = searchParams.get("rfxNr");
  const vendorId = searchParams.get("vendorId");

  useEffect(() => {
    if (rfxNr || vendorId) {
      setFormInputs((prev) => ({
        ...prev,
        rfxNr: rfxNr || "",
        vendorCode: vendorId || "",
      }));
    }
  }, [rfxNr, vendorId]);

  // eslint-disable-next-line
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const modalData = {
    title: "Quotation Creation",
    successMsg: "",
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);

  const [formInputs, setFormInputs] = useState({
    rfxNr: "",
    quotationSubmittedBy: "",
    qtnSubmittedID: "",
    qtnVersion: "V0",
    vendorCode: "",
    rfxCategoryDesc: "",
    rfqCreation: "",
    rfxDescription: "",
    rfxVersion: "",
    rfxTitle: "",
    openingrfxType: "",
    productType: "",
    rfxHeaderStatus: "",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    qtnPaymentTerms: "",
    qtnBidderCurrency: "",
    technicalQuoteArticle: "",
    qtnPricingNotes: "",
    unpricedCommercia: "",
    lQuoteArticle: "",
    quotationNotes: "",
    commercialQuoteArticle: "",
    quotationStatus: "",
    buyerResponsible: "",
    companyAddress: "",
    buyerEmail: "",
    initiatorName: "",
    initiator: "",
    createdOn: "",
    buyerConact: "",
    deliveryAddressCodeDesc: "",
    rfxCategoryType: "",
    rfxCateDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    openingDateTime: "",
    closingDateTime: "",
    rfxTypeDesc: "",
    productTypeDesc: "",
    rfxbidTypeDesc: "",
    rfxNoOfEvaluationTypeDesc: "",
    rfxCurrencyCode: "",
    rfxCurrencyDesc: "",
    technicalApprovalTypeDesc: "",
    companyAddressDesc: "",
    plantDesc: "",
    billingAddressDesc: "",
    unpricedCommercialQuoteArticle: "",
    pricingNotes: "",
    qtnIncoTerms: "",
    quotationReference: "",
    acceptanceTermsConditions: "",
    gemReferenceNr: "",
    items: [
      {
        qtnItem: 1,
        nstatusItem: "",
        qtnQuantity: 10,
        qtnQuantityUnit: "",
        purchaseDocumentNr: "",
        purchaseDocumentItem: "",
        quotationNr: "",
      },
    ],
    formCOMM: [],
    formTECH: [],
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const [formComm, setFormComm] = useState([]);
  const [formTech, setFormTech] = useState([]);

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // handleInputChange
  const handleInputChange = useCallback((obj, value, type) => {
    if (type === "formCOMM" || obj.textDesc === "formCOMM") {
      let data = {
        question_no: obj.textField || obj.componentId,
        question_name: obj.textCode || obj.question.label,
        question_value: obj.value || value,
      };

      setFormComm((prevFormComm) => {
        const updatedFormComm = prevFormComm.filter(
          (item) => item.question_no !== data.question_no
        );
        return [...updatedFormComm, data];
      });
    } else if (type === "formTECH" || obj.textDesc === "formTECH") {
      let data = {
        question_no: obj.textField || obj.componentId,
        question_name: obj.textCode || obj.question.label,
        question_value: obj.value || value,
      };

      setFormTech((prevFormTech) => {
        const updatedFormTech = prevFormTech.filter(
          (item) => item.question_no !== data.question_no
        );
        return [...updatedFormTech, data];
      });
    }
  }, []);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  const handleInputChangeTable = (id, value, qtnQuantity) => {
    let totalPriceVal = Number(qtnQuantity) * Number(value);

    const updatedData = itemTableData.map((item) => {
      return item.local_id === id
        ? {
            ...item,
            quotationUnitPrice: value,
            qtnitemValue: totalPriceVal,
          }
        : item;
    });

    setItemTableData(updatedData);
    getTotalCount(updatedData);
  };
  const handleDeliveryLeadTime = (id, value) => {
    const updatedData = itemTableData.map((item) => {
      return item.local_id === id
        ? {
            ...item,
            deliveryLeadTime: value,
          }
        : item;
    });
    setItemTableData(updatedData);
  };
  const handleDropdownChange = (data) => {
    setItemTableData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === data.index
          ? {
              ...row,
              [data.name]: data.value,
              [data.code]: data.codeValue,
              [data.desc]: data.descValue,
            }
          : row
      )
    );
  };

  const handleQtnQuantityTable = (id, value, qtnQuantity) => {
    if (Number(qtnQuantity) >= Number(value)) {
      const updatedData = itemTableData.map((item) => {
        return item.local_id === id
          ? {
              ...item,
              qtnQuantity: value,
            }
          : item;
      });

      setItemTableData(updatedData);
    } else {
      // console.log("Do Nothing");
    }
  };
  const getTotalCount = (data) => {
    const getTotal = data.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.qtnitemValue || 0),
      0
    );
    setSubTotalValue(getTotal);
  };

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Qtn Quantity ",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="qtnQuantity"
            name="qtnQuantity"
            value={row.qtnQuantity || 0}
            onChange={(e) =>
              handleQtnQuantityTable(
                row.local_id,
                e.target.value,
                row.purchaseQuantity
              )
            }
          />
        </>
      ),
      width: "160px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      width: "100px",
    },
    {
      name: "Unit Price ",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="quotationUnitPrice"
            name="quotationUnitPrice"
            value={row.quotationUnitPrice || 0}
            onChange={(e) =>
              handleInputChangeTable(
                row.local_id,
                e.target.value,
                row.qtnQuantity
              )
            }
          />
        </>
      ),
      width: "180px",
    },
    {
      name: "Item Value ", // calculation
      selector: (row) => formatPriceValue(row.qtnitemValue),
      width: "200px",
    },
    {
      name: "Delivery Lead Time (Days)", // input
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="deliveryLeadTime2"
            name="deliveryLeadTime"
            value={row.deliveryLeadTime || 0}
            onChange={(e) =>
              handleDeliveryLeadTime(row.local_id, e.target.value)
            }
          />
        </>
      ),
      width: "200px",
    },
    ...(productTypeCode !== "MAT"
      ? [
          {
            name: "Service Start Date", // input
            cell: (row) => (
              <>
                <InputField
                  type="date"
                  className="inputBox mt-1"
                  id="serviceStartDate3"
                  name="serviceStartDate"
                  value={row.serviceStartDate}
                  onChange={(e) =>
                    handleDeliveryLeadTime(row.local_id, e.target.value)
                  }
                />
              </>
            ),
            width: "200px",
          },
          {
            name: "Service End Date", // input
            selector: (row) => row.serviceEndDate || "--",
            cell: (row) => (
              <>
                <InputField
                  type="date"
                  className="inputBox mt-1"
                  id="serviceEndDate4"
                  name="serviceEndDate"
                  value={row.serviceEndDate}
                  onChange={(e) =>
                    handleDeliveryLeadTime(row.local_id, e.target.value)
                  }
                />
              </>
            ),
            width: "200px",
          },
        ]
      : []),

    {
      name: "Deviation", // input yes/NO
      selector: (row) => row.deviation || "--",
      cell: (row) => (
        <>
          <TableDropdownMenu
            index={row?.local_id}
            label={"Deviation"}
            data={dropdownOption}
            id={"deviation"}
            name={"deviation"}
            code={"deviationCode"}
            description={"deviationDescription"}
            onChange={handleDropdownChange}
          />
        </>
      ),
      width: "200px",
    },
    {
      name: "Deviation Remarks", // input
      selector: (row) => row.deviationRemark || "--",
      cell: (row) => (
        <>
          <TextAreaField
            className="inputBox mt-1"
            id="deviation"
            name="deviation"
            value={row.deviation}
          />
        </>
      ),
      width: "200px",
    },
  ];

  // Other Charges
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);

  /* Other Charges selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  useEffect(() => {
    const getTotal = getHeaderTextSelectedData.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(currentValue?.documentText || 0),
      0
    );
    setOtherChargesValue(getTotal);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHeaderTextSelectedData]);

  /* Create Other Charges Modal Function */
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Value",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
  ];

  const loadInitialPageData = async () => {
    const documentNo = rfxNr; // coming from URL //TND0031

    if (!documentNo) return; // safety guard

    const obj = {
      documentNumber: documentNo,
      queryName: "GET_RFX_Detail",
    };
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    try {
      const item = await ItemService.generateQueryV1(obj);
      if (item?.status === 200) {
        setVendorData(item?.data[0]);
        setData(item?.data?.[0]);
        const updatedItemData =
          item?.data[0]?.items?.map((obj, index) => ({
            ...obj,
            qtnItem: index + 1,
            local_id: index + 1,
            qtnQuantity: obj.purchaseQuantity,
          })) || [];

        setItemTableData(updatedItemData);
        setFormInputs(item.data[0]);
        updateTimerValue(item?.data[0]?.closingDateTime);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error("Failed to load RFQ details", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  const updateTimerValue = (closingDateTime) => {
    let timerData = {};
    const openingMoment = moment(); // This is the current date-time
    const closingMoment = moment(closingDateTime, "YYYY-MM-DD HH:mm");
    const diffInMilliseconds = closingMoment.diff(openingMoment);
    const duration = moment.duration(diffInMilliseconds);

    // If the time is already past, return 0 and set timeExpired flag
    if (diffInMilliseconds <= 0) {
      setFinalTimerValue({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
      setTimerStatus(true);
    } else {
      setTimerStatus(false);
      // Extract days, hours, minutes, and seconds correctly
      timerData.days = Math.floor(duration.asDays()) || 0;
      timerData.hours = duration.hours() || 0; // Remaining hours after days
      timerData.minutes = duration.minutes() || 0; // Remaining minutes after hours
      timerData.seconds = duration.seconds() || 0; // Remaining seconds after minutes
      setFinalTimerValue(timerData);
    }
  };

  const selectedVendor = vendorData?.supplierList?.find(
    (supplier) => supplier.AssociateNumber === vendorId
  );

  const selectedCurrency = vendorData?.data?.find(
    (item) => item.code === formInputs?.rfxCurrency
  );

  useEffect(() => {
    loadInitialPageData();
    getMasterDataFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxNr]);

  //Load Master Data
  const getMasterDataFunc = async () => {};

  // SAVE
  const handleSave = async () => {
    // let requiredFields = [];

    // if(!validateRequired(formInputs?.organisationName)) {
    //   requiredFields.push('*Please enter Supplier Name');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!validateEmail(formInputs?.email)) {
    //   requiredFields.push('*Invalid Contact Email address');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!getPOLineItemsData[0]?.materialCode) {
    //   toast.error("Alteast one PO Line item should be added.", {
    //     duration: 4000,
    //     position: "top-right",
    //   });
    //   return;
    // }
    // console.log(formInputs);
    // formInputs.vendorCode = userData?.data?.userId;
    // ✅ UNIT PRICE VALIDATION
    const invalidUnitPriceItem = itemTableData.find(
      (item) =>
        item.qtnQuantity > 0 &&
        (!item.quotationUnitPrice || Number(item.quotationUnitPrice) <= 0)
    );

    if (invalidUnitPriceItem) {
      toast.error(
        `Unit Price must be greater than 0 for Item No ${invalidUnitPriceItem.local_id}`,
        {
          duration: 4000,
          position: "top-right",
        }
      );
      return;
    }

    formInputs.qtnVersion = "V0";
    formInputs.quotationStatus = "Submitted";
    formInputs.quotationSubmittedBy = selectedVendor?.organisationName;
    formInputs.qtnSubmittedID = selectedVendor?.AssociateNumber;
    formInputs.vendorId = selectedVendor?.AssociateNumber;
    formInputs.othersCharge = getHeaderTextSelectedData;
    formInputs.qtnSubTotalLineItem = subTotalValue;
    formInputs.qtnSubTotalOtherCharges = getOtherChargesValue;
    formInputs.qtnTotal = subTotalValue + getOtherChargesValue;
    formInputs.qtnBidderCurrency = selectedCurrency?.name || "";
    formInputs.qtnBidderCurrencyCode = selectedCurrency?.code || "";
    formInputs.qtnBidderCurrencyDesc = selectedCurrency?.description || "";

    const userEnteredItemTableData = itemTableData.filter(
      (item) => item.purchaseQuantity != null || item.purchaseQuantity > 0
    );
    formInputs.items = userEnteredItemTableData;
    formInputs.formCOMM = formComm;
    formInputs.formTECH = formTech;
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: formInputs,
    };

    setDisabled(true);
    await ItemService.submitQuotationForTender(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();

        // Update response value in Redux Store
        dispatch(getTndQtnList({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };
  return (
    <main className="" id="">
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Quotation</h2>
            <p className="subText">Fil Quotatoin Details</p>
            <hr />

            {/*Remaining Time for submission  */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={12} md={5} lg={5} className="">
                      <p className="headerTitle fs-4">
                        Remaining Time for submission
                      </p>
                    </Col>
                    <Col xs={12} md={7} lg={7} className="flex justify-end">
                      <img
                        src="assets/img/stopwatch.png"
                        alt="stopwatch"
                        style={{ width: "60px", height: "58px" }}
                        className="mr-6 mt-1"
                      />
                      <PageLevelRiverseTimer timerData={finalTimerValue} />
                    </Col>
                  </Row>
                </h2>
              </div>
            </div>

            {/*quotation Header */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QH</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Quotation Header</span>
                      <span className="subHeaderTitle">Header Description</span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="RFQ ID"
                          name="rfxNr"
                          id="rfxNr"
                          placeholder=""
                          value={formInputs?.rfxNr}
                          disabled={getDisabledStatus}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Address"
                          name="companyAddressDesc"
                          id="companyAddressDesc"
                          placeholder=""
                          value={formInputs?.companyAddressDesc}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivery Address"
                          name="billingAddressDesc"
                          id="billingAddressDesc"
                          value={formInputs?.billingAddressDesc}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="quotationCreatedOn"
                          className="inputBox"
                          label="Quotation Created Date"
                          name="quotationCreatedOn"
                          placeholder=""
                          value={getCurrentDate("default")}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Billing Address"
                          name="billingAddressDesc"
                          id="billingAddressDesc"
                          value={formInputs?.billingAddressDesc}
                          // onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Responsible"
                          name="buyerResponsible"
                          id="buyerResponsible"
                          value={formInputs?.buyerResponsible}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product Type"
                          name="productType"
                          id="productType"
                          value={formInputs?.productType}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Contact"
                          name="buyerConact"
                          id="buyerConact"
                          value={formInputs?.buyerConact}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="RFQ Currency"
                          name="rfxCurrency"
                          id="rfxCurrency"
                          value={formInputs?.rfxCurrency}
                          disabled={getDisabledStatus}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="quotationStatus"
                          className="inputBox"
                          label="Quotation Status"
                          name="quotationStatus"
                          placeholder=""
                          value={"New"}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Price Shedule / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible4
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility4}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PI</span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <span className="headerTitle">
                        Price Shedule / Line Item
                      </span>
                      <span className="subHeaderTitle">
                        Price Shedule / Line Item
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible4 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={PRLineItemInitialCol}
                          data={itemTableData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* other Charges table */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OC</span>
                    </Col>

                    <Col xs={4} md={6} lg={6}>
                      <span className="headerTitle">Other Charges</span>
                      <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={4} lg={4} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={showsetHeaderText}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </Col>
                      {/* <Col xs={1} md={1} lg={1} className="">
                        <SourcingCommonFilter />
                      </Col> */}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={HeaderTextColumns}
                          data={getHeaderTextSelectedData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination

                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Pricing Summary */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PS</span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <span className="headerTitle">Pricing Summary</span>
                      <span className="subHeaderTitle">Pricing Summary </span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                >
                  <Row className="my-4 ms-3 ">
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="d-flex mb-2 jsutify-content-center align-items-center"
                    >
                      <p className="fw-medium">
                        SubTotal Pricing Schedule / Line Items (A){" "}
                      </p>
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={6}
                      className="d-flex mb-2 jsutify-content-center align-items-center"
                    >
                      <InputField
                        id="subTotalValue"
                        className="inputBox"
                        name="subTotalValue"
                        placeholder=""
                        value={subTotalValue}
                        disabled={getDisabledStatus}
                      />
                      <p className="ms-4 fw-medium">
                        {" "}
                        {formInputs?.rfxCurrency}
                      </p>
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="d-flex mb-2 jsutify-content-center align-items-center "
                    >
                      <p className="fw-medium"> SubTotal Other Charges (B)</p>
                    </Col>
                    <Col
                      xs={12}
                      md={7}
                      lg={7}
                      className="d-flex mb-2 jsutify-content-center align-items-center "
                    >
                      <InputField
                        id="getOtherChargesValue"
                        className="inputBox"
                        name="getOtherChargesValue"
                        placeholder=""
                        value={getOtherChargesValue}
                        disabled={getDisabledStatus}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="d-flex mb-2 jsutify-content-center align-items-center"
                    >
                      <p className="fw-medium">
                        Quotation Gross Total (C = A + B)
                      </p>
                    </Col>
                    <Col
                      xs={12}
                      md={7}
                      lg={7}
                      className="d-flex mb-2 jsutify-content-center align-items-center"
                    >
                      <InputField
                        id="totalValue"
                        className="inputBox"
                        /* label="Closing Date:" */
                        name="subTotal"
                        placeholder=""
                        value={subTotalValue + getOtherChargesValue}
                        onChange={onInputChange}
                        disabled={getDisabledStatus}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            {/* COMM - Spares & Operation Maintenance 08*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CC</span>
                    </Col>

                    <Col xs={4} md={8} lg={7}>
                      <span className="headerTitle">
                        Commercial Terms and Conditions
                      </span>
                      {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="commTopButtonRightLeftPadding">
                      {formInputs?.formCOMM?.length > 0 &&
                        formInputs?.formCOMM?.map((formJsonData, index) => {
                          const {
                            componentId,
                            mandatory,
                            question,
                            answerDefinition,
                            serialNo,
                          } = formJsonData;
                          const formType = "formCOMM";
                          switch (answerDefinition?.type) {
                            case "textarea":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commLeftRightPadding"
                                >
                                  <TextAreaField
                                    label={serialNo + ". " + question?.label}
                                    id={componentId}
                                    name={componentId}
                                    className="inputBox"
                                    placeholder=""
                                    // value={getRemarks}
                                    onChange={(e) =>
                                      handleInputChange(
                                        formJsonData,
                                        e.target.value,
                                        formType
                                      )
                                    }
                                    required={mandatory}
                                  />
                                </Col>
                              );
                            case "select":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label={serialNo + ". " + question?.label}
                                    placeholder=""
                                    data={answerDefinition?.options}
                                    id={componentId}
                                    iconClassName="dropdownIcon"
                                    name={componentId}
                                    code={question?.label}
                                    description={formType}
                                    required={mandatory}
                                    getvalue={handleInputChange}
                                    // setValue={formData.type || ""}
                                    // getvalue={setDropdownData}
                                  />
                                </Col>
                              );
                            case "radio":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
                                    {serialNo + ". " + question?.label}{" "}
                                    {mandatory && "*"}
                                  </label>

                                  {answerDefinition?.options.map(
                                    (option, index) => {
                                      return (
                                        <div key={index} className="block">
                                          <input
                                            type="radio"
                                            className="form-check-input fs-5 ml-3"
                                            id={`${componentId}-${index}`}
                                            name={componentId}
                                            value={option?.value}
                                            required={mandatory}
                                            onChange={(e) =>
                                              handleInputChange(
                                                formJsonData,
                                                e.target.value,
                                                formType
                                              )
                                            }
                                          />
                                          <span className="ml-3">
                                            {option?.value}{" "}
                                          </span>
                                        </div>
                                      );
                                    }
                                  )}
                                </Col>
                              );
                            case "checkbox":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
                                    {serialNo + ". " + question?.label}{" "}
                                    {mandatory && "*"}
                                  </label>

                                  {answerDefinition?.options.map(
                                    (option, index) => {
                                      return (
                                        <div key={index} className="block">
                                          <input
                                            type="checkbox"
                                            className="form-check-input fs-5 ml-3"
                                            id={`${componentId}-${index}`}
                                            name={componentId}
                                            value={option?.value}
                                            required={mandatory}
                                            onChange={(e) =>
                                              handleInputChange(
                                                formJsonData,
                                                e.target.value,
                                                formType
                                              )
                                            }
                                          />
                                          <span className="ml-3">
                                            {option?.value}{" "}
                                          </span>
                                        </div>
                                      );
                                    }
                                  )}
                                </Col>
                              );
                            case "text":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding block"
                                >
                                  <InputField
                                    label={serialNo + ". " + question?.label}
                                    type="text"
                                    className="inputBox"
                                    id={componentId}
                                    name={componentId}
                                    placeholder=""
                                    // value={option.value}
                                    required={mandatory}
                                    onChange={(e) =>
                                      handleInputChange(
                                        formJsonData,
                                        e.target.value,
                                        formType
                                      )
                                    }
                                  />
                                </Col>
                              );
                            case "number":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding block"
                                >
                                  <InputField
                                    label={serialNo + ". " + question?.label}
                                    type="number"
                                    className="inputBox"
                                    id={componentId}
                                    name={componentId}
                                    placeholder=""
                                    required={mandatory}
                                    onChange={(e) =>
                                      handleInputChange(
                                        formJsonData,
                                        e.target.value,
                                        formType
                                      )
                                    }
                                  />
                                </Col>
                              );
                            default:
                              return "";
                          }
                        })}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Form :TECH - Spares & Operation Maintenance09*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible9
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility9}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PS</span>
                    </Col>

                    <Col xs={4} md={8} lg={7}>
                      <span className="headerTitle">
                        Product / Service Verification
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible9 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="commTopButtonRightLeftPadding">
                      {formInputs?.formTECH?.length > 0 &&
                        formInputs?.formTECH?.map((formJsonData, index) => {
                          const {
                            componentId,
                            mandatory,
                            question,
                            answerDefinition,
                            serialNo,
                          } = formJsonData;
                          const formType = "formTECH";
                          switch (answerDefinition?.type) {
                            case "textarea":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commLeftRightPadding"
                                >
                                  <TextAreaField
                                    label={serialNo + ". " + question?.label}
                                    id={componentId}
                                    name={componentId}
                                    className="inputBox"
                                    placeholder=""
                                    // value={getRemarks}
                                    onChange={(e) =>
                                      handleInputChange(
                                        formJsonData,
                                        e.target.value,
                                        formType
                                      )
                                    }
                                    required={mandatory}
                                  />
                                </Col>
                              );
                            case "select":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label={serialNo + ". " + question?.label}
                                    placeholder=""
                                    data={answerDefinition?.options}
                                    id={componentId}
                                    iconClassName="dropdownIcon"
                                    name={componentId}
                                    code={question?.label}
                                    description={formType}
                                    required={mandatory}
                                    getvalue={handleInputChange}
                                    // setValue={formData.type || ""}
                                    // getvalue={setDropdownData}
                                  />
                                </Col>
                              );
                            case "radio":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
                                    {serialNo + ". " + question?.label}{" "}
                                    {mandatory && "*"}
                                  </label>

                                  {answerDefinition?.options.map(
                                    (option, index) => {
                                      return (
                                        <div key={index} className="block">
                                          <input
                                            type="radio"
                                            className="form-check-input fs-5 ml-3"
                                            id={`${componentId}-${index}`}
                                            name={componentId}
                                            value={option?.value}
                                            required={mandatory}
                                            onChange={(e) =>
                                              handleInputChange(
                                                formJsonData,
                                                e.target.value,
                                                formType
                                              )
                                            }
                                          />
                                          <span className="ml-3">
                                            {option?.value}{" "}
                                          </span>
                                        </div>
                                      );
                                    }
                                  )}
                                </Col>
                              );
                            case "checkbox":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
                                    {serialNo + ". " + question?.label}{" "}
                                    {mandatory && "*"}
                                  </label>

                                  {answerDefinition?.options.map(
                                    (option, index) => {
                                      return (
                                        <div key={index} className="block">
                                          <input
                                            type="checkbox"
                                            className="form-check-input fs-5 ml-3"
                                            id={`${componentId}-${index}`}
                                            name={componentId}
                                            value={option?.value}
                                            required={mandatory}
                                            onChange={(e) =>
                                              handleInputChange(
                                                formJsonData,
                                                e.target.value,
                                                formType
                                              )
                                            }
                                          />
                                          <span className="ml-3">
                                            {option?.value}{" "}
                                          </span>
                                        </div>
                                      );
                                    }
                                  )}
                                </Col>
                              );
                            case "text":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding block"
                                >
                                  <InputField
                                    label={serialNo + ". " + question?.label}
                                    type="text"
                                    className="inputBox"
                                    id={componentId}
                                    name={componentId}
                                    placeholder=""
                                    // value={option.value}
                                    required={mandatory}
                                    onChange={(e) =>
                                      handleInputChange(
                                        formJsonData,
                                        e.target.value,
                                        formType
                                      )
                                    }
                                  />
                                </Col>
                              );
                            case "number":
                              return (
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding block"
                                >
                                  <InputField
                                    label={serialNo + ". " + question?.label}
                                    type="number"
                                    className="inputBox"
                                    id={componentId}
                                    name={componentId}
                                    placeholder=""
                                    required={mandatory}
                                    onChange={(e) =>
                                      handleInputChange(
                                        formJsonData,
                                        e.target.value,
                                        formType
                                      )
                                    }
                                  />
                                </Col>
                              );
                            default:
                              return "";
                          }
                        })}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <div className="pageFooter">
        <Row className="rowDirection">
          {!timerStatus && (
            <>
              <Col
                xs={12}
                md={2}
                lg={2}
                className="commTopButtonRightLeftPadding"
              >
                <button
                  className="btn btnTable w-full"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
              {/* <Col xs={12} md={2} lg={2} className="commTopButtonRightLeftPadding">
            <button
              className="btn btnTable w-full"
              //  onClick={handleModify}
            >
              <i className="bi bi-pencil-square"></i> Modify
            </button>
          </Col> */}
            </>
          )}
        </Row>
      </div>
      <HeaderText
        index={0}
        headername="Add Other Charges"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="OtherChargesID"
        type="Number"
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_VENDOR_QUOTATION_LIST}
      />
    </main>
  );
};

export default CreateQuotation;
